import { render, staticRenderFns } from "./Add-User.vue?vue&type=template&id=18cfd9b2&scoped=true&"
import script from "./Add-User.vue?vue&type=script&lang=js&"
export * from "./Add-User.vue?vue&type=script&lang=js&"
import style0 from "./Add-User.vue?vue&type=style&index=0&id=18cfd9b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cfd9b2",
  null
  
)

export default component.exports